module.exports = __webpack_public_path__ + "img/Slice197.de1aed16.png";